/**
 * @file
 * Topic navigator script.
 */

(function topicNavigatorScript($, Drupal) {
  'use strict';

  Drupal.behaviors.topicNavigator = {
    attach: function topicNavigatorAttach(context) {
      var isMobile = false;
      var $navigator = $('.topic-navigator', context);

      $navigator.find('.topic-navigator__inner--show')
        .slideToggle();

      if ($(window).width() < 768) {
        var mobileToggleText = $('.topic-navigator__toggle--active', context).text();
        $navigator.find('.topic-navigator__mobile-toggle')
          .text(mobileToggleText);
        $navigator.addClass('topic-navigator--mobile');
        // Hide Show more/less and show all articles.
        $navigator.find('.topic-navigator__more-toggle').parent()
          .hide();
        $navigator.find('.topic-navigator__item--hidden')
          .removeClass('topic-navigator__item--hidden')
          .addClass('topic-navigator__item--shown');
        isMobile = true;
      }

      // Resize
      $(window).on('resize', _.throttle(function windowResize() {
        if ($(window).width() < 768) {
          var mobileToggleText = $('.topic-navigator__toggle--active', context).text();
          $navigator.find('.topic-navigator__mobile-toggle')
            .text(mobileToggleText);
          $navigator.addClass('topic-navigator--mobile');
          // Hide Show more/less and show all articles.
          $navigator.find('.topic-navigator__more-toggle').parent()
            .hide();
          $navigator.find('.topic-navigator__item--hidden')
            .removeClass('topic-navigator__item--hidden')
            .addClass('topic-navigator__item--shown');
          isMobile = true;
        }
        else {
          $navigator.removeClass('topic-navigator--mobile');
          // Show Show more/less and hide excess articles.
          $navigator.find('.topic-navigator__more-toggle').parent()
            .show();
          $navigator.find('.topic-navigator__item--shown')
            .removeClass('topic-navigator__item--shown')
            .addClass('topic-navigator__item--hidden');
          isMobile = false;
        }
      }, 400));

      // Top level toggle behavior.
      $('.topic-navigator__toggle', context)
        .hammer()
        .on('click', function (e) {
          e.preventDefault();
          var $this = $(this);

          if (!$this.hasClass('topic-navigator__toggle--active')) {
            $('.topic-navigator__toggle', context).removeClass('topic-navigator__toggle--active').attr('aria-expanded', 'false');
            $this.addClass('topic-navigator__toggle--active').attr('aria-expanded', 'true');
          }
          else {
            $this.removeClass('topic-navigator__toggle--active').attr('aria-expanded', 'false');
          }

          if ($this.next().hasClass('topic-navigator__inner--show')) {
            $this.next().removeClass('topic-navigator__inner--show');
            $this.next().slideUp();
          }
          else {
            var $navigatorInner = $this.parent().parent().find('li .topic-navigator__inner');
            $navigatorInner.removeClass('topic-navigator__inner--show')
              .slideUp();

            $this.next().toggleClass('topic-navigator__inner--show');
            $this.next().slideToggle();

            if (!isMobile) {
              $navigatorInner.find('.topic-navigator__item--shown')
                .removeClass('topic-navigator__item--shown')
                .addClass('topic-navigator__item--hidden');

              $this.next().find('.topic-navigator__more-toggle')
                .removeClass('topic-navigator__more-toggle--active')
                .attr('aria-expanded', 'false')
                .text(Drupal.t('Show more'));
            }
          }
        });

      // See more/less toggle behavior.
      $('.topic-navigator__more-toggle', context)
        .hammer()
        .on('click', function (e) {
          e.preventDefault();
          var $this = $(this);

          if (!$this.hasClass('topic-navigator__more-toggle--active')) {
            $this.addClass('topic-navigator__more-toggle--active').attr('aria-expanded', 'true');
            $this.parent().parent().append($this.parent());
            $this.parent().parent().find('.topic-navigator__item--hidden')
              .removeClass('topic-navigator__item--hidden')
              .addClass('topic-navigator__item--shown');
            $this.text(Drupal.t('Show less'));
          }
          else {
            $this.removeClass('topic-navigator__more-toggle--active').attr('aria-expanded', 'false');
            $this.parent().parent().find('.topic-navigator__item--shown')
              .removeClass('topic-navigator__item--shown')
              .addClass('topic-navigator__item--hidden');
            $this.parent().insertAfter($this.parent().siblings('.topic-navigator__item:nth-child(3)'));
            $this.text(Drupal.t('Show more'));
          }
        });

      // Mobile toggle behavior.
      $('.topic-navigator__mobile-toggle', context)
        .on('click', function (e) {
          e.preventDefault();
        })
        .hammer()
        .on('tap press', function () {
          var $this = $(this);

          if ($this.hasClass('topic-navigator__mobile-toggle--active')) {
            $this.removeClass('topic-navigator__mobile-toggle--active');
            $('.topic-navigator--mobile', context).css({height: 'auto'});
            $('body', context).removeClass('u-noscroll');
          }
          else {
            $this.addClass('topic-navigator__mobile-toggle--active');
            $('.topic-navigator--mobile', context).css({height: 'calc(100vh - 53px)'});
            $('body', context).addClass('u-noscroll');
          }

          $navigator.find('.topic-navigator__accordion')
            .slideToggle();
        });
    }
  };
}(jQuery, Drupal));
